import axios from 'axios';

interface ISocialProofApiResponse {
    data: {
        data: {
            post_id: string;
            html: string;
        }[];
    };
}

export interface ISocialProofApiPost {
    postId: string;
    html: string;
}

export function getSocialProofPosts(): Promise<ISocialProofApiPost[] | []> {
    try {
        return axios
            .get(`/home/api/socialproof/v2`)
            .then((response: ISocialProofApiResponse) => {
                if (response.data && response.data.data) {
                    const camelCaseData: ISocialProofApiPost[] = response.data.data.map((post) => {
                        return {
                            postId: post.post_id,
                            html: post.html,
                        };
                    });
                    return camelCaseData;
                }

                return [];
            })
            .catch(() => []);
    } catch {
        return Promise.resolve([]);
    }
}
